import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import { Storage } from '@capacitor/storage';
import { Preferences } from '@capacitor/preferences';
import { DOCUMENT } from '@angular/common';
import { storageKeys } from 'src/app/enum/storage-keys';

@Injectable({
  providedIn: 'root'
})

export class LanguageService {

  public selectedLang: string;

  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  setInitialAppLanguage() {

    const platLanguage = this.translate.getBrowserLang();
    console.log(platLanguage);

    Preferences.get({ key: storageKeys.SELECTED_LANGUAGE })
      .then(val => {

        if (val.value === null) {
          const language = platLanguage
          this.translate.setDefaultLang(language);
          this.setLanguage(language);
          return;
        }

        if(val.value != platLanguage) this.setLanguage(platLanguage);
        else this.setLanguage(val.value);
    });
  }


  setLanguage(lng: string) {
    this.selectedLang = lng;
    if(lng === 'ar')this.document.documentElement.dir = 'rtl';
    else this.document.documentElement.dir = 'ltr';

    this.translate.use(lng);
    Preferences.set({ key: storageKeys.SELECTED_LANGUAGE, value: lng });
  }


  getLanguages() {
    return [
      { text: 'English', value: 'en' },
      { text: 'العربية', value: 'ar' },
    ];
  }
}
